import React, { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { filesize } from "filesize";

import VideoThumbnail from 'react-video-thumbnail';

import styles from './style.module.scss'
import { SwitchMui } from "./switchMui";

let videos = []

export function UploadVideo({
  setVideoAnuncio,
  videoAnuncio,
  labelUploadImage,
  switchPositionAd,
  setSwitchPositionAd,
  allTypesImage
}) {
 const [styleDropZone, setStyleDropZone] = useState();
 const [files, setFiles] = useState([]);
 const [typeImages, setTypeImages] = useState(null)

 useEffect(() => {
  videos = []
 }, [])

 function checkAccept() {
  switch (allTypesImage) {
    case true:
      setTypeImages({'video/*': []});
      break;
    case false:
      setTypeImages({'video/*': []});
      break;
    default:
      break;
  }
 }
 
function checkStayleDrop() {
  if (isDragAccept) {
    setStyleDropZone(styles.dragActive);
  } else if (isDragReject) {
    setStyleDropZone(styles.dragReject);
  } else {
    setStyleDropZone(styles.dropContainer);
  }
}

 const {
   getRootProps,
   getInputProps,
   isDragActive,
   isDragReject,
   isDragAccept,
   acceptedFiles,
 } = useDropzone({
  accept: typeImages,
  onDrop: acceptedFiles => {
    getVideo(acceptedFiles)
    setVideoState()
  }
});

function getVideo(data) {
  let video = data.map((file) => Object.assign(file, {
    preview: URL.createObjectURL(file),
  }))
  videos.push(video[0]);
}

function setVideoState() {
  setVideoAnuncio(videos)
}

function Thumbs({video}) {
return (
    <div>
      <div className={styles.thumbVideo} key={video.name}>
          <div className={styles.thumbInnerVideo}>
            <VideoThumbnail
            videoUrl={video.preview}
            thumbnailHandler={null}
            width={100}
            height={100}
            />
          </div>
      </div>
      <span className={styles.descriptionThumb}>{video.path.slice(0, 38)}{video.path.length >= 38 ? '...' : ''} - Size: {filesize(video.size)}</span>
      <div>
      {setSwitchPositionAd &&
      <SwitchMui 
      optionSwitchCheck='Esquerda' 
      optionSwitchUncheck='Direita'
      label='Posição logo'
      switchResult={switchPositionAd}
      setSwitchResult={setSwitchPositionAd}
      />}
      </div>
    </div>
  )
}

 const renderDragMessage = useCallback(() => {
   if (!isDragActive) {
     return (
      <div className={styles.boxMsgUploa}>
        <p className={styles.UploadMessage}>Arraste e solte os videos aqui...</p>
        <em>(Tamanho maximo aceito é de 20Mbp)</em>
      </div>
     );
   }
   if (isDragReject) {
     return (
       <p
       type="error"
       className={styles.UploadMessageError}
       >
         Tipo de arquivo não suportado
       </p>
     );
   }
   return <p className={styles.UploadMessageSucess} type="success">Solte as imagens aqui</p>;
 }, [isDragActive, isDragReject, isDragAccept]);

 useEffect(() => {
  checkStayleDrop()
 })

 useEffect(() => {
  // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
  checkAccept()
  return () => files.forEach(file => URL.revokeObjectURL(file.preview));
}, []);

 return (
  <div className={styles.boxUpload}>
   <label className={styles.labelUpload}>{labelUploadImage}</label>
   <div className={styleDropZone} {...getRootProps()}>
     <input {...getInputProps()} />
     {renderDragMessage()}
   </div>
    <aside>
      {videos.map(file => {
        return (<Thumbs video={file} />)
      })}
    </aside>
  </div>
 )
}
